import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import React  from 'react'; 
function App() {
 
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          {/* <Route path="blogs" element={<Blogs />} />
          <Route path="contact" element={<Contact />} /> */}
          <Route
            path="*"
            element={
              <Navigate to="http://tekkabuzz.com/af/NV0RcqxB/winzir" />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
